<template>
  <section class="section-shaped bg-white py-5 my-0">
    <div class="row row-grid justify-content-center mb-5">
      <h1 class="text-dark">Links importantes</h1>
    </div>
    <div class="container">
      <b-row>
        <b-col
          v-for="(link, index) in links"
          :key="index"
          class="align-middle"
          :class="link.class"
          lg="6"
          md="12"
          sm="12"
        >
          <a
            :href="link.url"
            target="_blank"
          >
            <b-card
              border-variant="dark"
              no-body
              style="cursor: pointer"
              text-variant="black"
              class="mt-2 p-3 h6 text-center card-municipio"
              v-b-popover.hover.top="link.descricao"
              variant="outline-dark">
              {{ link.nome }}
            </b-card>
          </a>
        </b-col>
      </b-row>
    </div>
  </section>
</template>
<script>
    export default {
        name: 'SectionLinks',
        data() {
            return {
                links: [
                    {
                        "nome": "CNPJ - Comprovante de Inscrição e de Situação Cadastral",
                        "descricao": "Esta página tem como objetivo permitir a emissão do Comprovante de Inscrição e de Situação Cadastral de Pessoa Jurídica pela Internet em consonância com a Instrução Normativa RFB nº 1.634, de 06 de maio de 2016.",
                        "url": "https://solucoes.receita.fazenda.gov.br/servicos/cnpjreva/cnpjreva_solicitacao.asp"
                    },
                    {
                        "nome": "Simples Nacional  ",
                        "descricao": "O Simples Nacional é um regime compartilhado de arrecadação, cobrança e fiscalização de tributos aplicável às Microempresas e Empresas de Pequeno Porte, previsto na Lei Complementar nº 123, de 14 de dezembro de 2006.",
                        "url": "http://www8.receita.fazenda.gov.br/SimplesNacional/"
                    },
                    {
                        "nome": "Certidão do FGTS",
                        "descricao": "Consultar Certificado de Regularidade do FGTS – CRF. A CAIXA possibilita que você consulte on-line a situação da sua empresa perante o Fundo de Garantia do Tempo de Serviço – FGTS. Com essa facilidade, quem está em dia com as contribuições devidas pode obter na hora o Certificado de Regularidade do FGTS.",
                        "url": "https://consulta-crf.caixa.gov.br/consultacrf/pages/consultaEmpregador.jsf"
                    },
                    {
                        "nome": "CNDT",
                        "descricao": "Em cumprimento à Lei nº 12.440/2011 e à Resolução Administrativa TST nº 1470/2011, a Justiça do Trabalho emite, a partir de 4 de janeiro de 2012, a Certidão Negativa de Débitos Trabalhistas - CNDT, documento indispensável à participação em licitações públicas.",
                        "url": "http://www.tst.jus.br/certidao"
                    },
                    {
                        "nome": " Comprovante de Situação Cadastral do CPF",
                        "descricao": "Emitir o comprovante de situação cadastral. Situações cadastrais: regular, pendente de regularização, suspensa, cancelada ou nula.",
                        "url": "http://receita.economia.gov.br/interface/lista-de-servicos/cadastros/cpf/comprovante-de-situacao-cadastral-no-cpf"
                    },
                    {
                        "nome": "Certidão Negativa da SEFA - PA",
                        "descricao": "A presente Certidão, emitida nos termos do Decreto n.º 2.473, de 29 de setembro de 2006 , e  da Instrução Normativa n.º 0019, de 5 de Outubro de 2006, tem os mesmos efeitos da  Certidão Negativa e somente produzirá efeitos após a confirmação de sua autenticidade",
                        "url": "https://app.sefa.pa.gov.br/emissao-certidao/template.action"
                    },
                    {
                        "nome": " Cadastro Nacional de Condenações Cíveis",
                        "descricao": "Cadastro Nacional de Condenações Cíveis por Ato de Improbidade Administrativa e Inelegibilidade.",
                        "url": "https://www.cnj.jus.br/improbidade_adm/consultar_requerido.php"
                    },
                    {
                        "nome": "Certidão Negativa do Tribunal de Contas da União",
                        "descricao": "Art. 86. As certidões negativas emitidas pelo Tribunal têm prazo máximo de validade de trinta dias, devendo essa informação ser consignada expressamente nos documentos expedidos via internet. - Resolução TCU 259/2014",
                        "url": "https://contas.tcu.gov.br/ords/f?p=INABILITADO:CERTIDAO:0:"
                    },
                    {
                        "nome": "Certidão Negativa de Débitos Relativos a Créditos Tributários Federais e a Dívida Ativa da União",
                        "descricao": "A certidão negativa de débitos é o documento que comprova a regularidade fiscal de um contribuinte perante a Receita Federal do Brasil (RFB) e Procuradoria-Geral da Fazenda Nacional (PGFN)",
                        "url": "https://solucoes.receita.fazenda.gov.br/Servicos/certidaointernet/PJ/Emitir",
                        "class": 'col-lg-12'
                    },
                ]
            }
        },
    };
</script>
<style>
</style>
